import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { watch, computed } from 'vue'
import { useDateTimeStore } from '@/stores/DateTimeFilterStore'
import MsButton from '@/components/general/buttons/MsButton.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'LastXHoursButton',
  props: {
  isActive: Boolean,
  lastXhours: {
    type: Number,
    default: 24
  },
  name: {
    type: String,
    default: 'Last 24 h'
  }
},
  setup(__props) {

const props = __props

const { setDateTime } = useDateTimeStore()

watch(
  () => props.isActive,
  (newVal) => {
    if (newVal) {
      const dateTime = new Date()
      dateTime.setHours(dateTime.getHours() - props.lastXhours)

      setDateTime(dateTime)
    }
  }
)
const buttonFontStyle = computed(() => `${props.isActive ? 'NKT-P2-medium' : 'NKT-P2'}`)

const buttonClassStyle = computed(() => `btn-filter ${props.isActive ? 'active' : ''}`)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(MsButton, {
      "button-font": buttonFontStyle.value,
      "button-custom-style": buttonClassStyle.value
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(__props.name), 1)
      ]),
      _: 1
    }, 8, ["button-font", "button-custom-style"])
  ]))
}
}

})